import React from "react";
import { NavBarItemTitle, NavBarItemContainer } from "./NavBarItem.style";

interface NavBarItemProps {
  id: string;
  itemTitle: string;
  onClick: (id: string) => void;
  selected?: boolean;
  icon?: React.ReactNode;
}

const NavBarItem: React.FC<NavBarItemProps> = (props) => {
  const onClick = () => {
    props.onClick(props.id);
  };
  console.log(props);
  return (
    <NavBarItemContainer onClick={onClick}>
      <NavBarItemTitle selected={props.selected}>
        {props.icon} {props.itemTitle}
      </NavBarItemTitle>
    </NavBarItemContainer>
  );
};

export default NavBarItem;
